<template>
    <div id="resourceForm" class="con-exemple-prompt">
        <!-- Titre -->
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Libellé* :</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                    v-if="type != 'show'"
                    v-model="resource.title"
                    name="title"
                    size="large"
                    class="w-full"
                />
                <b v-else>{{ resource.title }}</b>
            </div>
        </div>

        <!-- Choix du type -->
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Type* :</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <template v-if="type != 'show'">
                    <div
                        ref="tooltip"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Cette donnée permet de catégoriser vos question. Vous pouvez sélectionner une valeur existante ou en ajouter une nouvelle.">

                        <TypeForm
                            v-model="resource.type"
                            :availableTypes="types.data"
                        ></TypeForm>
                    </div>
                </template>
                <span v-else>{{ resource.type }}</span>
            </div>
        </div>

        <!-- Signification des réponses -->
        <div class="mb-10">
            <vs-collapse accordion class="mb-6 mt-10">
                <vs-collapse-item>
                    <div slot="header">
                        <h5>Signification des réponses : </h5>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col sm:w-2/5 w-full flex items-center justify-start">
                            <b>0 - Pas du tout d'accord : </b>
                        </div>
                        <div class="input-level vx-col sm:w-3/5 w-full">
                            <span v-if="type == 'show'">{{ resource.levels.level_0 }}</span>
                            <vs-input 
                                v-else 
                                v-model="resource.levels.level_0" 
                                name="levels_level_0" 
                                class="w-full"
                                placeholder="0 : " 
                                type="text" 
                            />
                        </div>
                    </div>
                    <div class="vx-row mt-3">
                        <div class="vx-col sm:w-2/5 w-full flex items-center justify-start">
                            <b>1 - Plutôt pas d'accord : </b>
                        </div>
                        <div class="input-level vx-col sm:w-3/5 w-full">
                            <span v-if="type == 'show'">{{ resource.levels.level_1 }}</span>
                            <vs-input 
                                v-else 
                                v-model="resource.levels.level_1" 
                                name="levels_level_1" 
                                class="w-full"
                                placeholder="1 : " 
                                type="text"
                            />
                        </div>
                    </div>
                    <div class="vx-row mt-3">
                        <div class="vx-col sm:w-2/5 w-full flex items-center justify-start">
                            <b>2 - Plutôt d'accord : </b>
                        </div>
                        <div class="input-level vx-col sm:w-3/5 w-full">
                            <span v-if="type == 'show'">{{ resource.levels.level_2 }}</span>
                            <vs-input 
                                v-else 
                                v-model="resource.levels.level_2" 
                                name="levels_level_2" 
                                class="w-full"
                                placeholder="2 : " 
                                type="text" 
                            />
                        </div>
                    </div>
                    <div class="vx-row mt-3">
                        <div class="vx-col sm:w-2/5 w-full flex items-center justify-start">
                            <b>3 - Tout à fait d'accord : </b>
                        </div>
                        <div class="input-level vx-col sm:w-3/5 w-full">
                            <span v-if="type == 'show'">{{ resource.levels.level_3 }}</span>
                            <vs-input 
                                v-else 
                                v-model="resource.levels.level_3" 
                                name="levels_level_3" 
                                class="w-full"
                                placeholder=" 3 : " 
                                type="text" 
                            />
                        </div>
                    </div>
                </vs-collapse-item>
            </vs-collapse>
        </div>

        <div class="mt-10">
            <ItemsSelector 
                v-if="type != 'show'"
                v-model="resource.questions"
                label="Questions associées"
                :availables="questions.data"
                :loading="questions.loading"
                :groupBy="(item) => item.type"
                :template="(item) => item.title"
                :searchBy="['title']"
                searchText="Filtrer les questions disponibles"
                dragText="Glissez-déposez les questions que vous souhaitez ajouter :"
                availableText="Questions disponibles"
                selectedText="Questions sélectionnées"
                emptyText="Aucune question n'a encore été créée"
                addText="Ajouter une nouvelle question"
                addUrl="/rh/referentiel/questions?create=true"
            />
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import TypeForm from "@components/form/TypeForm";
import ItemsSelector from "@components/form/ItemsSelector";

export default {
    name: 'BlocForm',
    components: {
        Multiselect,
        TypeForm,
        ItemsSelector
    },
    props: {
        value: {
            required: false,
            type: Object
        },
        type: {
            required: true,
            type: String
        },
        isCreation: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            log: console.log,
            resource: {
                levels: {},
                questions: []
            },
            types: {
                data: [],
                loading: false
            },
            questions: {
                data: [],
                loading: false
            },
            fileError: {
                message: null,
            },
        }
    },
    watch: {
        value (newValue, oldValue) {
            if (newValue === oldValue) return
            this.initResource()
        },
        'resource': {
            handler () {
                this.value.title       = this.resource.title
                this.value.type        = this.resource.type
                this.value.description = this.resource.description
                this.value.levels      = {...this.resource.levels}
                this.value.questions   = [...this.resource.questions]
                this.$emit('input', this.value)
            }, deep: true
        },
        hasError (value) {
            this.$emit('error', value)
        }
    },
    computed: {

        hasError() {
            let error = !this.resource.title || !this.resource.type
            return error;
        },

    },
    methods: {
        async loadTypes() {
            this.types.loading = true

            return window.axios({
                method: 'get',
                url: '/api/referentiel/blocs/types',
            })
            .then(response => {
                this.types.data = response.data;
                this.types.loading = false;
            })
            .catch((err) => {
                console.log(err)
                this.notifyError(err, `Une erreur est survenue`)
            })
        },

        async loadQuestions() {
            this.questions.loading = true

            return window.axios({
                method: 'get',
                url: '/api/referentiel/questions',
                params: {perpage: 999}
            })
            .then(response => {
                this.questions.data = response.data.data;
                this.questions.loading = false;
            })
            .catch((err) => {
                console.log(err)
                this.notifyError(err, `Une erreur est survenue`)
            })
        },

        setAudioDescription(ev) {
            this.fileError.message = null
            this.resource.audio_description_blob = null

            if (ev.target.files.length !== 0) {
                Array.from(ev.target.files).forEach(file => {
                    if (file.size >= this.maxFileSize*1024*1024) {
                        this.fileError.message = 'La taille du fichier de '+this.getReadableFileSizeString(file.size)+' est supérieure à la valeur autorisée de ' + this.maxFileSize+' Mo'
                    } else {
                        this.$set(this.resource, 'audio_description_blob', file)
                    }
                })
            }
        },
        submitPhoto(ev) {
            ev.getCroppedCanvas({ width: 512, height: 512 }).toBlob(blob => {
                    this.resource.photo_blob = blob
                    this.resource.photo = URL.createObjectURL(blob)
                },
                'image/jpeg',
                0.9
            )
        },
        
        initResource() {

            this.resource = {
                type: this.value.type,
                title: this.value.title,
                description: this.value.description,
                levels: {...this.value.levels},
                questions: [...this.value.questions]
            }

            const searchParams = new URLSearchParams(window.location.search);

            if (searchParams.has('questions')) {
                searchParams.get('questions').split(',').forEach(id => {
                    this.resource.questions.push(this.questions.data.find(os => os.id == id));
                })
            }
        },

    },
    created() {
        this.initResource();

        this.$vs.loading();
        Promise.all([
            this.loadTypes(),
            this.loadQuestions(),
        ]).then(() => {
            this.$vs.loading.close();
        });
    }
}
</script>
